$(function () {
    var $review_container = $('#r_Reviews');
    if ($review_container.length == 0) {
        return;
    }
    var siteId = 2;
    var reviewSite = "https://a2.giftsjourney.com";
    var pid = $review_container.attr('data-product-id');
    var url = reviewSite + "/reviews/list/" + siteId + "/" + pid;
    var review_frame = '<iframe id="rReviewsFrame" src="' + url +
        '" height="0" width="100%" frameborder="0" scrolling="no" margin="0" style="overflow:hidden;height:1px;width:100%;"></iframe>';
    $review_container.append(review_frame);

    var wirte_url = reviewSite + "/reviews/write/" + siteId + "/" + pid;
    var modalPopup = [
        '<div id="review_modal" data-remodal-id="review_modal">',
        '<button data-remodal-action="close" class="remodal-close"></button>',
        '<div style="font-size: 0;"><iframe id="write_review_Frame" src="' + wirte_url +
        '" width="100%" height="680px" scrolling="no" frameborder="0" margin="0" style="overflow:hidden;height:680px;max-width:700px;"></iframe></div>',
        '</div>'
    ];

    $('body').append(modalPopup.join(''));
    var write_review_Modal = $('#review_modal').remodal({
        hashTracking: false,
        closeOnOutsideClick: false
    });
    $(document).on('closed', '#review_modal', function (e) {
        $('#write_review_Frame').attr('src', wirte_url);
        var frame = document.getElementById("write_review_Frame");
        frame.height = '680px';
        frame.style.height = '680px';
        frame.parentNode.style.height = '680px';
    });

    var ask_url = reviewSite + "/reviews/ask/" + siteId + "/" + pid;
    var ask_modal = [
        '<div id="ask_modal" data-remodal-id="ask_modal">',
        '<button data-remodal-action="close" class="remodal-close"></button>',
        '<div style="font-size: 0;"><iframe id="ask_question_Frame" src="' + ask_url +
        '" width="100%" height="430px" scrolling="no" frameborder="0" margin="0" style="overflow:hidden;height:430px;max-width:700px;"></iframe></div>',
        '</div>'
    ];

    $('body').append(ask_modal.join(''));
    var ask_question_Modal = $('#ask_modal').remodal({
        hashTracking: false,
        closeOnOutsideClick: false
    });
    $(document).on('closed', '#ask_modal', function (e) {
        $('#ask_question_Frame').attr('src', ask_url);
    });


    var gallery_modal = [
        '<div id="gallery_modal" data-remodal-id="gallery_modal">',
        '<button data-remodal-action="close" class="remodal-close"></button>',
        '<div style="font-size: 0;"><img id="review_img" width="100%" alt="Review Image" src=""></img></div>',
        '</div>'
    ];

    $('body').append(gallery_modal.join(''));
    var gallery_Modal = $('#gallery_modal').remodal({
        hashTracking: false
    });
    $(document).on('closed', '#gallery_modal', function (e) {
        $('#review_img').attr('src', "");
    });

    function r_listener(event) {
        if (event.origin != reviewSite)
            return;

        var m = typeof (event.data) == "string" ? JSON.parse(event.data) : event.data;
        if (m.type == 'resize') {
            var frame = document.getElementById(m.frame);
            frame.height = m.height + 'px';
            frame.style.height = m.height + 'px';
            frame.parentNode.style.height = m.height + 'px';
        }

        if (m.type == 'write') {
            if (!!write_review_Modal) {
                write_review_Modal.open();
            }
        }

        if (m.type == 'ask') {
            if (!!ask_question_Modal) {
                ask_question_Modal.open();
            }
        }

        if (m.type == 'gallery') {
            if (!!gallery_Modal) {
                var review_url = reviewSite + m.data;
                $('#review_img').attr('src', review_url);
                gallery_Modal.open();
            }
        }
    }
    window.addEventListener ? addEventListener("message", r_listener, false) : attachEvent("onmessage", r_listener);
});